import { useTranslation } from 'react-i18next';
/**
 * VariableEditor — small key/value editor used inside Contract create
 * and edit dialogs for ad-hoc `input.*` token values.
 */
import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Plus, Trash2 } from 'lucide-react';

export default function VariableEditor({ value, onChange, disabled }) {
  const { t } = useTranslation();
  const entries = Object.entries(value || {});
  const setKv = (k, v) => onChange({ ...value, [k]: v });
  const addRow = () => {
    let i = 1;
    while ((`key_${i}`) in (value || {})) i += 1;
    onChange({ ...(value || {}), [`key_${i}`]: '' });
  };
  const removeRow = (k) => {
    const next = { ...(value || {}) };
    delete next[k];
    onChange(next);
  };
  return (
    <div className="space-y-1">
      {entries.length === 0 && (
        <div className="text-xs text-slate-400 italic">No custom variables. Click + to add tokens accessible as &#123;&#123;input.your_key&#125;&#125;</div>
      )}
      {entries.map(([k, v]) => (
        <div key={k} className="flex gap-1 items-center">
          <Input className="h-7 text-xs w-48" value={k} disabled={disabled}
            onChange={(e) => {
              const next = { ...value };
              const old = next[k];
              delete next[k];
              next[e.target.value] = old;
              onChange(next);
            }} />
          <span className="text-slate-400 text-xs">=</span>
          <Input className="h-7 text-xs flex-1" value={v || ''} disabled={disabled}
            onChange={(e) => setKv(k, e.target.value)} />
          {!disabled && (
            <Button size="icon" variant="ghost" className="h-7 w-7" onClick={() => removeRow(k)}>
              <Trash2 className="h-3.5 w-3.5 text-red-500" />
            </Button>
          )}
        </div>
      ))}
      {!disabled && (
        <Button size="sm" variant="outline" onClick={addRow} className="h-7 text-xs" data-testid="btn-addrow">
          <Plus className="h-3 w-3 mr-1" /> {t('auto.ctr.addVariable')}
        </Button>
      )}
    </div>
  );
}
